export enum BuddyStatus {
	// USED in the pivot buddy collection
	/**
	 * The mentee has completed the questionnaire and is waiting for a buddy to be assigned
	 */
	WAITING_FOR_BUDDY = "waiting-for-buddy",
	/**
	 * The mentee has been assigned a buddy after matching
	 */
	IN_PROGRESS = "in-progress",
	/**
	 * THe employee journey with buddy duty has been completed
	 */
	COMPLETED = "completed",
}

export enum UserBuddyStatus {
	/**
	 * The added employee but not assigned as a buddy
	 */
	NOT_A_BUDDY = "not-a-buddy",
	/**
	 * The new employee has been invited to the buddy program, to complete the questionnaire
	 */
	INVITED = "invited",
	/**
	 * The employee has been rejected from the buddy program
	 */
	REJECTED = "rejected",
	/**
	 * The employee is available by completing the questionnaire
	 * waiting for a buddy matching process to be assigned as a buddy
	 */
	AVAILABLE = "available",
	/**
	 * The employee has been assigned as a buddy and is not completed the questionnaire
	 */
	INCOMPLETE_QUESTIONAIRE = "incomplete-questionnaire",
	/**
	 * The employee buddy status is inactive, so the employee is not available for the buddy program
	 */
	INACTIVE = "inactive",
	/**
	 * The employee buddy status is on pause, so the employee is not available for the buddy program
	 * until the given date in the database
	 */
	ON_PAUSE = "on-pause",
	/**
	 * The employee buddy status is on duty.
	 */
	ON_DUTY = "on-duty",
}

export interface AddEmployeeFormValues {
	employees: {
		name: string;
		email: string;
		startDate: Date;
		locale: string;
		isBuddy: boolean;
		isLegacy: boolean;
		department: {
			name: string;
		};
		branchLocation: {
			name: string;
		};
		employeeJourneyId: string;
	}[];
}
